import Fab from '@mui/material/Fab'
import Tooltip from '@mui/material/Tooltip'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useTranslation } from 'react-i18next'

/** Lena's number. The E.164 form is what wa.me needs; nothing else belongs here. */
const PHONE_E164 = '358440922651'

/**
 * WhatsApp, on every page, impossible to miss.
 *
 * <p>Most enquiries for a place like this arrive on WhatsApp, and a guest deciding at eleven at
 * night should not have to find the contact page first. There is a link in the header too; this
 * is the one a thumb lands on.
 *
 * <p>It sits on the opposite edge from the review widget and the scroll buttons, using
 * {@code insetInlineStart} so Hebrew moves it to the other side without a second rule. A
 * {@code wa.me} link opens the visitor's own WhatsApp, so nothing is needed on the server.
 */
export function WhatsAppButton() {
  const { t } = useTranslation()

  return (
    <Tooltip title={t('nav.whatsappUs')} placement="right">
      <Fab
        component="a"
        href={'https://wa.me/' + PHONE_E164}
        target="_blank"
        rel="noopener"
        aria-label={t('nav.whatsappUs')}
        sx={{
          position: 'fixed',
          bottom: 24,
          insetInlineStart: 24,
          zIndex: 1200,
          bgcolor: '#25D366',
          color: 'common.white',
          '&:hover': { bgcolor: '#1da851' },
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  )
}
